var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenOriginal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "open_original_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#open_original_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.757 16.583c-.375 0-.692-.132-.951-.396a1.3 1.3 0 01-.389-.944V4.756c0-.365.13-.68.389-.944.259-.263.576-.395.95-.395h10.488c.375 0 .692.132.951.395a1.3 1.3 0 01.389.944v10.487c0 .366-.13.68-.389.944-.259.264-.576.396-.951.396H4.757zm0-1.083h10.487a.245.245 0 00.176-.08.245.245 0 00.08-.177V4.756a.245.245 0 00-.08-.176.245.245 0 00-.176-.08H4.757a.245.245 0 00-.177.08.245.245 0 00-.08.176v10.487c0 .065.027.123.08.177.054.053.113.08.177.08zm2.038-1.708h6.479a.3.3 0 00.289-.185.33.33 0 00-.034-.355l-1.945-2.6c-.068-.1-.154-.15-.26-.15-.105 0-.192.05-.26.15l-1.83 2.364-1.032-1.292a.303.303 0 00-.255-.142c-.103 0-.188.05-.256.15l-1.144 1.52c-.089.114-.102.232-.04.355.062.123.158.185.288.185zm.205-6a.763.763 0 00.56-.232.763.763 0 00.232-.56.763.763 0 00-.232-.56.763.763 0 00-.56-.232.763.763 0 00-.56.232.763.763 0 00-.231.56c0 .219.077.406.231.56a.763.763 0 00.56.232z",
    fill: "#7A8D8F"
  }))));
}
export default SvgOpenOriginal;